export default [
  {
    path: '',
    name: 'plusVIP',
    meta: {
      title: '长律plus会员',
      activity: true
    },
    component: () => import('@/views/plusPage/index.vue')
  },
  {
    path: 'plusFlow',
    name: 'plusFlow',
    meta: {
      title: '购买确认',
      activity: true
    },
    component: () => import('@/views/plusPage/payIndex.vue')
  },
  {
    path: 'plusPassword',
    name: 'plusPassword',
    meta: {
      title: '验证码确认',
      activity: true
    },
    component: () => import('@/views/plusPage/password.vue')
  },
  {
    path: 'plusResult',
    name: 'plusResult',
    meta: {
      title: '支付',
      activity: true
    },
    component: () => import('@/views/plusPage/payResult.vue')
  },
]